/**
 * LMG Image Zoom — magnifier en hover sobre imagen activa del PDP.
 * - Solo desktop (>=750px), respeta touch devices
 * - Lente circular que sigue cursor mostrando zoom 2.5x
 * - Source de la imagen ampliada: misma img pero servida en mayor res via image_url
 * - Auto-detecta cambios en la imagen activa (cuando se cambia variante o thumbnail)
 */
(function () {
  if (!document.querySelector('.product') && !document.querySelector('product-info')) return;

  // Detect touch
  if (window.matchMedia('(hover: none)').matches) return;
  if (window.innerWidth < 750) return;

  var ZOOM = 2.5;
  var LENS_SIZE = 180;
  var lensEl = null;
  var attached = new WeakSet();

  function ensureLens() {
    if (lensEl) return lensEl;
    lensEl = document.createElement('div');
    lensEl.className = 'lmg-zoom-lens';
    lensEl.setAttribute('aria-hidden', 'true');
    document.body.appendChild(lensEl);
    return lensEl;
  }

  function highRes(src) {
    // Strip Shopify size suffix and request larger
    return src.replace(/_(\d+x\d*|small|medium|large|grande|master|pico|icon|thumb|compact)(@2x)?(\.(jpg|jpeg|png|webp))/i, '$3')
              .replace(/(\?|&)width=\d+/i, '$1width=1600');
  }

  function attach(img) {
    if (attached.has(img)) return;
    attached.add(img);

    img.addEventListener('mouseenter', function () {
      if (window.innerWidth < 750) return;
      var lens = ensureLens();
      var hr = highRes(img.currentSrc || img.src);
      lens.style.backgroundImage = 'url("' + hr + '")';
      lens.style.width = LENS_SIZE + 'px';
      lens.style.height = LENS_SIZE + 'px';
      lens.setAttribute('data-visible', 'true');
      img.style.cursor = 'zoom-in';
    });

    img.addEventListener('mousemove', function (e) {
      var lens = ensureLens();
      if (lens.getAttribute('data-visible') !== 'true') return;
      var rect = img.getBoundingClientRect();
      var x = e.clientX - rect.left;
      var y = e.clientY - rect.top;
      if (x < 0 || y < 0 || x > rect.width || y > rect.height) {
        lens.removeAttribute('data-visible');
        return;
      }
      // Position lens centered on cursor
      lens.style.left = (e.clientX - LENS_SIZE / 2) + 'px';
      lens.style.top = (e.clientY + window.scrollY - LENS_SIZE / 2) + 'px';
      // Background position: relative cursor over image, scaled by ZOOM
      var bgX = (x / rect.width) * 100;
      var bgY = (y / rect.height) * 100;
      lens.style.backgroundSize = (rect.width * ZOOM) + 'px ' + (rect.height * ZOOM) + 'px';
      lens.style.backgroundPosition = bgX + '% ' + bgY + '%';
    });

    img.addEventListener('mouseleave', function () {
      var lens = ensureLens();
      lens.removeAttribute('data-visible');
      img.style.cursor = '';
    });
  }

  function scan() {
    // Active media in product gallery
    var selectors = [
      '.product__media-item:not([hidden]) img',
      '.product-media-container img',
      '.product__media img',
      'product-info .product__media img'
    ];
    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(attach);
    });
  }

  function init() {
    scan();
    // Re-scan when variant changes or media changes
    var obs = new MutationObserver(function () { scan(); });
    obs.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'src', 'srcset'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
